import router from './router'
import store from './store'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import {
  getToken, setToken, getVisitorToken, getAppId, getExhibitionId, noEnterRouter,
  getWhiteList, workBenchList, getRegSetIdentityList, isPathMatched, visitorRegisterAuthority
} from '@/utils/auth'
import business from '@/utils/business'
import config from './config/index'
import { getVisitorAuditState } from '@/api/index'
window.PC.Cancel = []

NProgress.configure({ showSpinner: false })

//初始化设置
;(function () {
  // 设置展会id
  store.commit('SET_EXHIBITIONID', getExhibitionId())
  // 设置应用id
  store.commit('SET_APPID', getAppId())
})()

/**
 * 每次页面跳转都初始化token
 */
const tokenInit = function (to) {
  const visitorToken = getVisitorToken();
  let token = getToken()
  // 判断当前路由角色是否是游客
  if (!noEnterRouter('', to)) {
    let t = !store.getters.isLogin  && (!store.getters.info || (store.getters.info && !store.getters.info.id))
    if (!token || t) {
      token = visitorToken
      setToken(token)
    }
    // 设置身份 展商(ACTOR)、观众(VISITOR)、游客(空字符串)
    if (token == visitorToken) {
      store.commit('SET_SUBJECTTYPE', 'ACTOR')
    }
  }

  return token
}

// 白名单 不需要登录
const whiteList = getWhiteList()
// 注册流程中需要强制设置身份的路由
const regSetIdentityList = getRegSetIdentityList()
// 登录成功后限制路由 默认跳转页面
// const defaultRoute = '/company-management'
// const defaultRoute = '/company-info'
const defaultRoute = '/operationGuide'


router.beforeEach(async (to, from, next) => {
  while (window.PC.Cancel.length > 0) {
    window.PC.Cancel.shift()('cancel')
  }

  // 是否开启禁止访问页面
  if (config.settings.noAction && to.path != '/') {
    next({ path: '/' })
    return
  }

  // 是否开发展商限制
  if (config.settings.noActor && !business.ActorNoTodo(true)) {
    store.dispatch("LogOut").then(() => {
      next({ path: '/' })
    })
    return
  }
  tokenInit(to)
  const subjectType = store.getters.subjectType
  NProgress.start()
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    let lastChat = to.meta.title.substr(to.meta.title.length - 1, 1)
    if (lastChat === '.') {
      document.title = window.PC.$t2(to.meta.title + to.params.type)
    } else {
      document.title = window.PC.$t2(to.meta.title)
    }
  }
  /**
   * 存在token
   * 且 是登录状态
   * 且 存在用户信息 且 存在用户id
   * 且 存在身份(ACTOR, VISITOR)
   * token && (store.getters.isLogin && store.getters.info && store.getters.info.id) && subjectType
   */
  if (business.isLoginStatus()) {
    if (to.path === '/login') {
      next({ path: defaultRoute })
      NProgress.done()
    } else {
      // 黑名单
      if (noEnterRouter(subjectType, to)) {
        next({ path: defaultRoute })
      } else {
        
        // 观众注册流程页面访问的权限
        if (!visitorRegisterAuthority(subjectType, store.getters.info, to)) {
            next({ path: '/' })
            NProgress.done()
            return false
        }

        // 根据后台接口返回的权限列表数据来判断是否跳转页面
        if (subjectType === 'ACTOR' && JSON.stringify(store.getters.checkBannedList) === '{}') {
            await store.dispatch('GetCheckBannedList')
        }
        if (business.actorLimit(to)) {
            if (from.name) {
                next({ path: from.path })
            } else {
                next({ path: defaultRoute })
            }
            NProgress.done()
            return false 
        }

        /**
         * 用户权限判断
         * 是否完成预登记
         */
        const status = workBenchList(subjectType, store.getters.info, to)
        if (status === true) {
          // 完成预登记
          next()
        } else {

          const t = from.name == 'login' || from.name == 'questionnaire'

          // 未预登记
          if (status === false) {
            window.PC.noUnregisteredDiag(() => {
              business.loginSuccess(subjectType, {}, null, { secondInfo: true })
            })
          }

          /**
           * 观众完成预登记 没有审核通过/待审核
           * 且 来自登录页面/问卷页面
           * 直接调转首页
           */
          if (t) {
            next({ path: '/' })
            NProgress.done()
            return false
          }

          // 国内用户 完成预登记 审核未通过
          if (status === 1) {
            window.PC.noUnregisteredDiag(() => {
            }, null, 'auditTip1', 'ok')
          }

          // 国内用户 完成预登记 待审核
          if (status === 2) {
            window.PC.noUnregisteredDiag(() => {
              // 通过接口判断是否审核通过
              getVisitorAuditState().then(res => {
                return res.data
              }).then(res => {
                if (!res.data) return
                let info = store.getters.info
                info.visitor.auditState = res.data
                switch (res.data) {
                  case 'APPROVE':
                    // 审核通过
                    store.dispatch('LogOut').then(() => {
                      business.loginSource({replaceStatus: true})
                    })
                    break
                  case 'DISAPPROVE':
                    // 审核不通过
                    store.commit('SET_INFO', info)
                    break
                }
              })
            }, null, 'auditTip', 'ok')
          }

          next({ path: from.path })
          NProgress.done()
        }

      }
    }

    if ((!store.state.sendingUser || (store.state.sendingUser && store.state.imRole === 'tourist')) 
      && store.state.isChatConnecting !== 'waiting') {
      store.dispatch('chatLogin', store.getters.imAccount)
    }

  } else {
    // 未登录状态

    const toLogin = function () {
      window.sessionStorage.setItem('toPath', to.path);
      next(`/login`)
      NProgress.done()
    }

    const noLogin = function () {
      // 游客的token
      if (isPathMatched(whiteList, to.path)) {
        /**
         * 进入之前判断 是否有身份
         * 是 在免登录白名单，直接进入
         * 否 跳转登录
         * 
         * 进入设置密码页面不需要身份
         * 如果在setTypeList中，强制设置身份
         */
        if (!subjectType && noEnterRouter(subjectType, to) && !isPathMatched(regSetIdentityList, to.path)) {
          toLogin()
        } else {
          if (isPathMatched(regSetIdentityList, to.path)) {
            if (to.params.type == 'vis') {
              store.commit('SET_SUBJECTTYPE', 'VISITOR')
            } else if (to.params.type == 'actor') {
              store.commit('SET_SUBJECTTYPE', 'ACTOR')
            }
          }
          next()
        }
      } else {
        toLogin()
      }
    }

    /**
     * 未登录状态
     * 且 (登录状态 或 存在用户信息且存在用户id 或没有身份) 时 需要退出重新登录
     * 否 需要去登录
     *  || !subjectType
     */
    if (store.getters.isLogin || (store.getters.info && store.getters.info.id)) {
      store.dispatch("LogOut").then(() => {
        tokenInit(to)
        noLogin()
      })
    } else {
      noLogin()
    }
  }

})

/* eslint-disable-next-line */
router.afterEach((to, from) => {
  /**
   * 广告分享链接统计浏览（主页和登录页面）
   */
  business.hostAdvertisingSharingStatistics()
  NProgress.done()  
})
